import type { ColumnsType, AnyObject } from "@similarweb/pro-logic-components";

import { DefaultCell, TrafficShareWithVisits, UrlCellWebsiteAnalysis } from "app/components/React/Table/cells";
import { NO_DATA_SIGN } from "app/filters/const";
import { translate } from "app/filters/i18nFilter";
import { volumeFormatter } from "app/pages/market-research/features/traffic-by-country/utils";
import { SHOW_PAID_LANDING_PAGE_AD_SPEND_COLUMN } from "app/pages/website-analysis/traffic-sources/search/common/showPaidLandingPageAdSpendColumn";
import { allTrackers } from "app/services/track/track";

import { USD_SIGN } from "../../consts";
import { renderChangeCell } from "../TableCells/tableCells";

import { TopKeywordsCell } from "./components/TopKeywordsCell";
export const getTopPaidColumns = (hideChange?: boolean): ColumnsType<AnyObject> => {
    const onUrlClicked = () => {
        allTrackers.dispatchTrackEvent("External Link", "click", "Top paid landing pages");
    };

    const columns: ColumnsType<AnyObject> = [
        {
            title: translate("website.analysis.search.overview.top.paid.landing.pages.table.column.url"),
            dataIndex: "url",
            width: 297,
            render: (rowCellData) => {
                const handleClick = () => {
                    onUrlClicked();
                };
                return (
                    <div onClick={handleClick}>
                        <UrlCellWebsiteAnalysis
                            {...rowCellData}
                            value={rowCellData}
                        />
                    </div>
                );
            },
        },
        {
            title: translate("website.analysis.search.overview.top.paid.landing.pages.table.column.clicks"),
            dataIndex: "clicks",
            align: "left",
            width: hideChange ? 220 : 172,
            render: ({ clicks, clicksShare }) => (
                <TrafficShareWithVisits
                    row={{ TotalVisits: clicks }}
                    value={clicksShare}
                    applyAbbrNumberFilter
                    thresholdForTotalFilter={50}
                    undefinedSign={NO_DATA_SIGN}
                />
            ),
        },
    ];

    if (!hideChange) {
        columns.push({
            title: translate("global.change.mom"),
            dataIndex: "moMChange",
            width: 96,
            align: "right",
            render: (value) => renderChangeCell(value),
        });
    }

    if (SHOW_PAID_LANDING_PAGE_AD_SPEND_COLUMN) {
        columns.push({
            title: translate("website.analysis.search.overview.top.paid.landing.pages.table.column.spend"),
            dataIndex: "spend",
            width: 90,
            align: "right",
            render: (value) => <DefaultCell value={`${value && USD_SIGN}${volumeFormatter(value)}`} />,
        });
    }

    columns.push({
        title: translate("website.analysis.search.overview.top.paid.landing.pages.table.column.top.keywords"),
        dataIndex: "keywords",
        width: 240,
        align: "left",
        render: (value) => <TopKeywordsCell {...value} />,
    });

    return columns;
};
